import { render, staticRenderFns } from "./AModulosPrograma.vue?vue&type=template&id=91dc7f50"
import script from "./AModulosPrograma.vue?vue&type=script&lang=js"
export * from "./AModulosPrograma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports